// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widget-wrapper {
  display: flex;
}
.widget-wrapper ion-icon {
  width: 26px;
  height: 26px;
  color: var(--ion-color-medium);
}
.widget-wrapper .trash-action-wrapper {
  margin-right: 8px;
}
.widget-wrapper .main-content-wrapper {
  width: 100%;
}
.widget-wrapper .main-content-wrapper ion-col {
  padding: 0;
}
.widget-wrapper .main-content-wrapper .conversation-source-wrapper {
  display: flex;
  align-items: center;
}
.widget-wrapper .main-content-wrapper .conversation-source-wrapper .icon-wrapper {
  background: var(--boxx-app-lightgray, #dedede);
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  display: flex;
  padding: 6px;
  margin-right: 8px;
}
.widget-wrapper .main-content-wrapper .conversation-source-wrapper .icon-wrapper.open {
  background: none;
  border-radius: unset;
  padding: 0;
}
.widget-wrapper .main-content-wrapper .conversation-source-wrapper .icon-wrapper.open ion-avatar {
  width: 36px;
  height: 36px;
}
.widget-wrapper .main-content-wrapper .conversation-source-wrapper ion-label {
  font-size: 14px;
  font-weight: 500;
  color: var(--ion-color-primary);
}
.widget-wrapper .main-content-wrapper .conversation-source-wrapper .conversation-name.open {
  font-weight: 600;
}
.widget-wrapper .main-content-wrapper .conversation-date {
  font-size: 12px;
  font-weight: 500;
  color: var(--ion-color-medium);
}
.widget-wrapper .main-content-wrapper .conversation-details-wrapper {
  padding-top: 8px;
}
.widget-wrapper .main-content-wrapper .conversation-details-wrapper .sender-name {
  line-height: 1;
  font-size: 15px;
  font-weight: 600;
  color: var(--ion-color-primary);
}
.widget-wrapper .main-content-wrapper .conversation-details-wrapper .sender-email {
  font-size: 14px;
  font-weight: 500;
  color: var(--ion-color-medium);
}
.widget-wrapper .main-content-wrapper .conversation-details-wrapper .message-brief {
  font-size: 14px;
  font-weight: 600;
  color: var(--ion-color-primary);
}
.widget-wrapper .main-content-wrapper .conversation-details-wrapper .message-brief.open {
  margin-bottom: 8px;
}
.widget-wrapper .main-content-wrapper .phone-wrapper {
  display: flex;
  justify-content: flex-end;
  color: var(--ion-color-primary);
  font-size: 14px;
  font-weight: 600;
}
.widget-wrapper .main-content-wrapper .phone-wrapper ion-icon {
  width: var(--phone-icon-size, 20px);
  height: var(--phone-icon-size, 20px);
  color: var(--phone-icon-color, var(--ion-color-medium));
  margin: var(--phone-icon-margin, 0 8px 0 0);
}
.widget-wrapper .main-content-wrapper .review-rating-wrapper {
  margin-bottom: -8px;
  padding-top: 16px;
  text-align: right;
}
.widget-wrapper .main-content-wrapper .review-rating-wrapper.open {
  text-align: left;
}
.widget-wrapper .main-content-wrapper .review-rating-wrapper .review-stars-icon {
  color: var(--ion-color-medium);
  width: 16px;
  height: 16px;
}
.widget-wrapper .main-content-wrapper .review-rating-wrapper .review-stars-icon.active {
  color: #f0c300;
}
.widget-wrapper .main-content-wrapper .message-reply {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 16px;
  color: var(--ion-color-primary);
  font-size: 14px;
  font-weight: 600;
}
.widget-wrapper .main-content-wrapper .message-reply ion-icon {
  color: var(--ion-color-primary);
  width: 18px;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/messages-core/lib/components/conversation-item-open/conversation-item-open.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AAAE;EACE,WAAA;EACA,YAAA;EACA,8BAAA;AAEJ;AACE;EACE,iBAAA;AACJ;AAEE;EACE,WAAA;AAAJ;AACI;EACE,UAAA;AACN;AAEI;EACE,aAAA;EACA,mBAAA;AAAN;AAEM;EACE,8CAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;AAAR;AAEQ;EACE,gBAAA;EACA,oBAAA;EACA,UAAA;AAAV;AACU;EACE,WAAA;EACA,YAAA;AACZ;AAGM;EACE,eAAA;EACA,gBAAA;EACA,+BAAA;AADR;AAIM;EACE,gBAAA;AAFR;AAKI;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;AAHN;AAMI;EACE,gBAAA;AAJN;AAKM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;AAHR;AAKM;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;AAHR;AAKM;EACE,eAAA;EACA,gBAAA;EACA,+BAAA;AAHR;AAIQ;EACE,kBAAA;AAFV;AAOI;EACE,aAAA;EACA,yBAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;AALN;AAOM;EACE,mCAAA;EACA,oCAAA;EACA,uDAAA;EACA,2CAAA;AALR;AASI;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;AAPN;AAQM;EACE,gBAAA;AANR;AAQM;EACE,8BAAA;EACA,WAAA;EACA,YAAA;AANR;AAQQ;EACE,cAAA;AANV;AAWI;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;AATN;AAUM;EACE,+BAAA;EACA,WAAA;AARR","sourcesContent":[".widget-wrapper {\n  display: flex;\n  ion-icon {\n    width: 26px;\n    height: 26px;\n    color: var(--ion-color-medium);\n  }\n\n  .trash-action-wrapper {\n    margin-right: 8px;\n  }\n\n  .main-content-wrapper {\n    width: 100%;\n    ion-col {\n      padding: 0;\n    }\n\n    .conversation-source-wrapper {\n      display: flex;\n      align-items: center;\n\n      .icon-wrapper {\n        background: var(--boxx-app-lightgray, #dedede);\n        border-radius: 8px;\n        align-items: center;\n        justify-content: center;\n        width: 36px;\n        height: 36px;\n        display: flex;\n        padding: 6px;\n        margin-right: 8px;\n\n        &.open {\n          background: none;\n          border-radius: unset;\n          padding: 0;\n          ion-avatar {\n            width: 36px;\n            height: 36px;\n          }\n        }\n      }\n      ion-label {\n        font-size: 14px;\n        font-weight: 500;\n        color: var(--ion-color-primary);\n      }\n\n      .conversation-name.open {\n        font-weight: 600;\n      }\n    }\n    .conversation-date {\n      font-size: 12px;\n      font-weight: 500;\n      color: var(--ion-color-medium);\n    }\n\n    .conversation-details-wrapper {\n      padding-top: 8px;\n      .sender-name {\n        line-height: 1;\n        font-size: 15px;\n        font-weight: 600;\n        color: var(--ion-color-primary);\n      }\n      .sender-email {\n        font-size: 14px;\n        font-weight: 500;\n        color: var(--ion-color-medium);\n      }\n      .message-brief {\n        font-size: 14px;\n        font-weight: 600;\n        color: var(--ion-color-primary);\n        &.open {\n          margin-bottom: 8px;\n        }\n      }\n    }\n\n    .phone-wrapper {\n      display: flex;\n      justify-content: flex-end;\n      color: var(--ion-color-primary);\n      font-size: 14px;\n      font-weight: 600;\n\n      ion-icon {\n        width: var(--phone-icon-size, 20px);\n        height: var(--phone-icon-size, 20px);\n        color: var(--phone-icon-color, var(--ion-color-medium));\n        margin: var(--phone-icon-margin, 0 8px 0 0);\n      }\n    }\n\n    .review-rating-wrapper {\n      margin-bottom: -8px;\n      padding-top: 16px;\n      text-align: right;\n      &.open {\n        text-align: left;\n      }\n      .review-stars-icon {\n        color: var(--ion-color-medium);\n        width: 16px;\n        height: 16px;\n\n        &.active {\n          color: #f0c300;\n        }\n      }\n    }\n\n    .message-reply {\n      display: flex;\n      align-items: center;\n      justify-content: flex-end;\n      margin-top: 16px;\n      color: var(--ion-color-primary);\n      font-size: 14px;\n      font-weight: 600;\n      ion-icon {\n        color: var(--ion-color-primary);\n        width: 18px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
